import type { UserInfoUpdateRequestAPI } from '@cobliteam/api-lib/src/account/session/ApiTypes';
import { SessionManager } from '@cobliteam/api-lib/src/account/session/SessionManager';
import type { Session } from '@cobliteam/common-types';
import useSessionStore from '@cobliteam/hooks/src/useSession/store/useSessionStore';
import { Environment } from '@cobliteam/react-environments';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

const env = Environment.getInstance().getEnvironment();
const sessionManager = new SessionManager({ host: env.herbieApiHost });

/**
 * Atualiza os dados do usuário e re-hidrata a sessão com o retorno do backend. Preserva o
 * comportamento e as mensagens do antigo `requestUpdateAccountSaga`.
 */
const useUpdateAccount = () => {
  const setSession = useSessionStore((s) => s.setSession);

  return useMutation<Session, unknown, UserInfoUpdateRequestAPI>({
    mutationFn: (payload) => sessionManager.update(payload),
    onSuccess: (session) => {
      setSession(session);
      toast.success('Dados alterados com sucesso');
    },
    onError: () => toast.error('Erro. Tente novamente.'),
  });
};

export default useUpdateAccount;
